export default {
  title: "Воронка",
  activeDrivers_one: "{{count}} активный водитель",
  activeDrivers_few: "{{count}} активных водителя",
  activeDrivers_many: "{{count}} активных водителей",
  activeDrivers_other: "{{count}} активных водителей",
  loadFailed: "Не удалось загрузить воронку.",
  conflictTitle: "Изменено другим пользователем",
  conflictDesc: "{{who}} только что обновил(а) {{name}}. Доска обновлена.",
  conflictDescAnon: "Кто-то обновил {{name}}. Доска обновлена.",
  network: "Нет связи с сервером. Проверьте подключение.",
  scope: { my: "Мои водители", myBranch: "Мой филиал", branch: "Филиал #{{id}}", all: "Все филиалы" },
  noDrivers: "Нет водителей",
  more: "+{{n}} ещё · используйте фильтры",
  rejectZone: "Перетащите сюда для отклонения · причина обязательна",
  rejectZoneOptional: "Перетащите сюда, чтобы отклонить",
  hired: "Hired · {{n}} →",
  filters: {
    recruiter: "Рекрутер",
    allRecruiters: "Все рекрутеры",
    job: "Перевозчик / вакансия",
    allCarriers: "Все перевозчики",
    source: "Источник",
    search: "Фильтр по имени или телефону",
  },
  card: {
    overdue: "{{label}} · просрочено",
    next: "Далее: {{label}} · {{when}}",
    firstCall: "Далее: Первый звонок",
    collectDocs: "Далее: Собрать документы",
    waitCarrier: "Ожидание перевозчика",
    waitBg: "Ожидание проверки",
    confirmOrientation: "Подтвердить дату ориентации",
    cdlExp: "CDL до {{date}}",
    cdlNone: "CDL до —",
    daysInStage: "{{n}} дней на этом этапе",
    days: "{{n}}д",
    unassigned: "Не назначен",
  },
  move: {
    title: "Перевести в {{status}}",
    which: "{{name}} · какая вакансия?",
    markHired: "Отметить нанятым",
    submit: "Подать",
    noJobs: "Нет открытых вакансий. Попросите менеджера добавить в Jobs.",
    onlyOpen: "Показаны только открытые вакансии.",
    startDate: "Дата начала",
    evidence: "Подтверждение / заметка",
    note: "Заметка к подаче",
    hiredHint: "Hired засчитывается после одобрения менеджера (Approvals).",
    placeholderHired: "Перевозчик подтвердил по email…",
    placeholderNote: "Чистый MVR, 2 года dry van",
  },
  reject: {
    title: "Отклонить {{name}}",
    titlePlain: "Отклонить",
    desc: "Водитель покидает воронку. Причина обязательна и попадает в историю статусов.",
    rejectDriver: "Отклонить водителя",
    notInterested: "Отметить как не заинтересован",
    rejectedOpt: "Отклонён (перевозчиком или нами)",
    notInterestedOpt: "Не заинтересован",
    reason: "Причина",
    chooseReason: "Выберите причину…",
    note: "Заметка",
    notePlaceholder: "Необязательные детали для истории",
  },
};
